import React, { Component } from 'react';
// import { connect } from 'react-redux';
import _ from 'lodash';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import BRSpan from '../General/BRSpan';
// import { loopIndex } from '../../utils/shared';

class DonorName extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    switchNameStatus = (status) => {
        this.setState({
            show: status
        })
    }

    render() {
        return (
            <CSSTransitionGroup
              component='div'
              transitionName='slowfadedelay'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
              <div key={this.state.show}>
                {
                    this.state.show ?
                    <span style={{ ...this.props.style, fontSize: `${this.props.style.fontSize}vh`, fontFamily: 'Roboto' }}><BRSpan str={this.props.name}/></span>
                    :null
                }
              </div>
          </CSSTransitionGroup>
        );
    }

    
}

export default DonorName;


// WEBPACK FOOTER //
// ./src/Components/Donor/DonorName.jsx